import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Permissions } from "../domain/user-profile/permissions";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base.service";
import { Agency } from "../domain/agency";
import { mapper } from "../tools/mapping/mapper";
import { AgencyDTO } from "./dto/agency.dto";
import { UserDTO } from "./dto/user.dto";
import { User } from "../domain/user";
import { Role } from "../domain/user-profile/role";
import { RoleDTO } from "./dto/role.dto";

@Injectable({
    providedIn: 'root',
})
export class UserService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/user`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getRolePermissions() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/Role`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getRoles')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: RoleDTO) => {
                return mapper.map(response, RoleDTO, Role);
            }));
    }

    getUserAgencyList() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/agency`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getUserAgencyList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: AgencyDTO[]) => {
                return response.map((item: AgencyDTO) => {
                    return mapper.map(item, AgencyDTO, Agency);
                });
            }));
    }

    getMyAgency() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/agency/my`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMyAgency')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: AgencyDTO) => {
                return mapper.map(response, AgencyDTO, Agency);
            }));
    }

    getSamplerByAgencyList(analyticalUnitCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/sampler/my/${analyticalUnitCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getSamplerByAgencyList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: UserDTO[]) => {
                return response.map((item: UserDTO) => {
                    return mapper.map(item, UserDTO, User);
                });
            }));
    }

    getAllSampler() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/agency`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getAllSampler')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: UserDTO[]) => {
                return response.map((item: UserDTO) => {
                    return mapper.map(item, UserDTO, User);
                });
            }));
    }

    sendConfirmationMailToSampler(puid: string, date: string, analyticalUnitCode: string) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/${puid}/${date}/${analyticalUnitCode}/planningComplete`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('sendConfirmationMailToSampler')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    updateUser(user: User) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/${user.Puid}`, user, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updateUser')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

}